module.exports = __webpack_public_path__ + "media/images/career_camp/2023/stats_illustration_3-af44a0dea274bb8f4e92a8aa8a4d80aa.svg";